import axios from 'axios'
import _ from 'underscore'
import Vue from 'vue'
import { languageManager } from '@/mixins/LanguageManager'
const state = {
  activeSectionElements: []
}
const mutations = {
  SET_ACTIVE_SECTIONS: function (state, payload) {
  },
  SET_ACTIVE_SECTION_ELEMENTS: function (state, payload) {
    Vue.set(state, 'activeSectionElements', payload.elements)
  }
}

const actions = {
  getActiveSectionsInPage ({ commit, state, getters }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/data/pageSections/get', {
          query: { page: payload.pageName, 'status.default': 'enabled' }
        })
        .then(rslt => {
          resolve(rslt)
        })
        .catch(err => reject(err))
    })
  },
  getActiveSectionElements ({ dispatch, commit, state, getters }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/data/pageSectionElements/get', {
          query: { parent: payload.parent, 'status.default': 'enabled' },
          filters: {
            sort: { created: 1 }
          }
        })
        .then(rslt => {
          let elements = _.map(rslt.data, transform)
          commit('SET_ACTIVE_SECTION_ELEMENTS', { elements })
          /* axios
            .post('api/data/getFile/pageSectionElement', {
              id: _.map(elements, el => el.mainImage[0].id)
            })
            .then(result => {
              const urls = _.pluck(result.data, 'fileUrl')
              _.each(elements, (el, index) => (el.image = urls[index]))
              commit('SET_ACTIVE_SECTION_ELEMENTS', { elements })
            }) */

          resolve(rslt)
        })
        .catch(err => reject(err))
    })
  }
}

const getters = {
  activeSectionElements: state => {
    return state.activeSectionElements
  }
}

function transform (element) {
  const keys = _.pluck(element.fields, 'name')
  keys.push('id')
  const values = _.pluck(element.fields, 'values')
  values.push(element.id)
  return _.object(keys, _.map(values, languageManager.methods.activeLanguage))
}

export default { state, getters, mutations, actions }
